export const environment = {
  apiUrl: 'https://vega.ennova-research.com',
  paymentTransactionUrl: 'https://merchant-portal.preprod.worldline-solutions.com/transactions/online?page=1&size=10&reference='
};
